"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTypeToFocus = exports.default = void 0;
var _isPrintableKeyEvent = _interopRequireDefault(require("is-printable-key-event"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _useKeyStrokes = require("./useKeyStrokes");
/**
 * Hook to handle "type to focus" behavior on a list of focusable candidates.
 * Handles keystrokes and focuses matching candidate item.
 * @returns keydown event handler for the node containing the focusable candidates.
 */
const useTypeToFocus = ({
  focusCandidates = [],
  keyStrokeTimeout = 50,
  useSpaces = false,
  focusMatchingItem
}) => {
  const {
    keyStrokes,
    setKeyStrokes
  } = (0, _useKeyStrokes.useKeyStrokes)({
    keyStrokeTimeout,
    onKeyStrokes: typedString => focusMatchingItem(typedString, focusCandidates)
  });
  const handleTypeToFocus = event => {
    var _a, _b;
    if (!event.ctrlKey && !event.metaKey && (0, _isPrintableKeyEvent.default)(event)) {
      event.stopPropagation();
      const nextKeyStroke = ((_b = (_a = (0, _keycode.default)(event)) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, 'numpad ', '')) || '';
      setKeyStrokes(keyStrokes + nextKeyStroke);
    } else if (useSpaces && (0, _keycode.default)(event) === 'space') {
      setKeyStrokes(`${keyStrokes} `);
    }
  };
  return {
    handleTypeToFocus
  };
};
exports.useTypeToFocus = useTypeToFocus;
var _default = exports.default = useTypeToFocus;